import { Button, useAssetRegistry } from "@cca/components";

export type ActivityPlayerPreviousButtonProps = {
  disabled?: boolean;
  onClick: () => void;
};

export const ActivityPlayerPreviousButton = ({
  disabled,
  onClick,
}: ActivityPlayerPreviousButtonProps) => {
  const { validateAll } = useAssetRegistry();

  const handleOnClick = () => {
    if (!validateAll()) return;

    onClick();
  };
  return (
    <Button
      disabled={disabled}
      onClick={handleOnClick}
      type="button"
      variant="outlined"
    >
      Back
    </Button>
  );
};
